import './tripItem.css'
import tripImage from '../../assets/images/Rectangle 757.png'
import iconInfo from '../../assets/images/Overflow.png'
import flag from '../../assets/images/flag.png'
import guest from '../../assets/images/guest.png'
import dot from '../../assets/images/Ellipse 272.png'
import mail from '../../assets/images/mail.png'
import share from '../../assets/images/Vector (6).png'
import duplicate from '../../assets/images/Edit.png'
import deleteBtn from '../../assets/images/Vector (7).png'
import { useState } from 'react'
import React from 'react'
import Modal from './Modal'
// import { recentTrips } from '../dummyJson'
import { dateRangeFormat } from '../../util'
import { isEmpty } from 'lodash'

export default function TripItem({ recentTrips }) {
  const [modalActive, setModalActive] = useState(false)
  const handleClick = () => {
    setModalActive(true)
    console.log('im clicked')
  }
  const disappearInfo = () => {
    setModalActive(false)
  }
  return (
    <>
      {recentTrips.map((data) => {
        return (
          <div className="tripItem">
            <img className="trimImage" src={tripImage} alt="tripImage" />
            <div className="tripInfo">
              <div className="name">
                <p className="headline2" style={{ color: 'var(--gray100)' }}>
                  {data.trip_name}
                </p>
                <div
                  className="additional"
                  onClick={handleClick}
                  onBlur={disappearInfo}
                >
                  <img src={iconInfo} alt="info" />
                </div>
              </div>
              <div className="country">
                <p className="body3">
                  {data.address.city + ', ' + data.address.country}
                </p>
                <div className="flag">
                  <img src={flag} alt="flag" />
                </div>
              </div>
              <div className="details">
                <p className="body3">
                  {dateRangeFormat(data.start_date, data.end_date)}
                </p>
                <div className="guests">
                  <img
                    style={{ width: '3px', height: '3px' }}
                    src={dot}
                    alt="dot"
                  />
                  <img
                    src={guest}
                    alt="guest"
                    style={{ width: '8.7px', height: '9.75px', margin: '5px' }}
                  />
                  <p className="body3">{data.total_guest}</p>
                </div>
                <div className="trip-amount">
                  <img
                    style={{ width: '3px', height: '3px', marginRight: '5px' }}
                    alt="dot"
                  />
                  <p className="body3"> {data.price} </p>
                </div>
              </div>
              <div className="contacts">
                <div className="email-content">
                  <img style={{ marginRight: '2px' }} src={mail} alt="mail" />
                  <p className="body3">{data.email}</p>
                </div>
                <div className="trip-date">
                  <img
                    style={{ width: '3px', height: '3px' }}
                    src={dot}
                    alt="dot"
                  />
                  <p className="body3">12/11/22</p>
                </div>
              </div>

              <div className="category-text">
                {data.tags.map((tag) => {
                  return <p className="body3">{tag + ', '} </p>
                })}
              </div>
            </div>
            <Modal active={modalActive} setActive={setModalActive}>
              <div className="modal_detail">
                <div className="modal-icon">
                  <img src={share} alt="share" />
                </div>
                <p style={{ margin: '5px' }}>Share trip</p>
              </div>
              <div className="modal_detail">
                <div className="modal-icon">
                  <img src={duplicate} alt="duplicate" />
                </div>
                <p style={{ margin: '5px' }}>Duplicate trip</p>
              </div>
              <div className="modal_detail">
                <div className="modal-icon">
                  <img src={deleteBtn} alt="delete" />
                </div>
                <p style={{ margin: '5px', color: 'red' }}>Delete trip</p>
              </div>
            </Modal>
          </div>
        )
      })}
      {isEmpty(recentTrips) && 'No Trip Found...'}
    </>
  )
}
